/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

export class CommonConstants {
    public static RETRY_COUNT = 1;
    public static SERVICE_BASE_PATH = '/LiveTime/services';
    public static SERVICE_VERSION_PATH_V1 = '/v1';
    public static STORE_COMPONENT = '/store';
    public static REQUEST_COMPONENT = '/requests';
    public static SELFHELP_COMPONENT = '/selfhelp';
    public static SELFHELP_KBA_COMPONENT = '/selfhelp/kba';
    public static ITEMS_COMPONENT = '/items';
    public static SERVICES_COMPONENT = '/services';
    public static OUTAGES_COMPONENT = '/outages';
    public static CURRENT_OUTAGES_COMPONENT = '/currentoutages';
    public static PLANNED_OUTAGES_COMPONENT = '/plannedoutages';
    public static REPORT_INCIDENT_COMPONENT = '/report-incident';
    public static NEWREQUEST_COMPONENT = '/newrequest';
    public static QUICKCALL_COMPONENT = '/quickcall';
    public static MYPROFILE_COMPONENT = '/my-profile';
    public static HOME_COMPONENT = '/home';
    public static SURVEY_COMPONENT = '/survey';
}
